import type { Producer, Trackers, Usina } from "../types";

function hasMeaningfulProducer(producers?: Producer[]): boolean {
  return !!producers?.some(
    (producer) =>
      !!(
        producer.contactEmail?.trim() ||
        producer.contactPhone?.trim() ||
        producer.portalAccessLink?.trim() ||
        producer.portalAccessUsername?.trim() ||
        producer.portalAccessPassword?.trim()
      ),
  );
}

function hasTrackersConfig(trackers?: Trackers): boolean {
  if (!trackers) return false;

  if (trackers.amount != null && trackers.amount > 0) {
    return true;
  }

  return hasMeaningfulProducer(trackers.producers);
}

export function usinaHasTrackers(
  usina: Pick<Usina, "components" | "uGs">,
): boolean {
  if (hasTrackersConfig(usina.components?.trackers)) {
    return true;
  }

  return !!usina.uGs?.some((ug) => hasTrackersConfig(ug.components?.trackers));
}
